<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="subjectsState.list"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      @input="onInput"
      :clearable="isClearable"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="subjectsState.loading"
          :style="{ opacity: subjectsState.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay destinos para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ListSubjects',
  computed: {
    ...mapGetters('List', [
      'subjectsState'
    ]),
    optionSelected() {
      return this.subjectsState.list.find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled
        || !this.subjectsState.list.length
        || this.subjectsState.loading;
    }
  },
  methods: {
    ...mapActions('List', [
      'fetchSubjects'
    ]),
    onInput(event) {
      this.$emit('input', event?.value);
    },
    getOption() {
      return this.subjectsState.list.find((option) => option.value === this.value);
    }
  },
  created() {
    if (this.nested) {
      // TODO: this.clearDocuments();
      this.$watch('parentValue', (newValue, oldValue) => {
        this.$emit('input', '');
        if (newValue !== oldValue) {
          if (oldValue !== '') {
            this.$emit('input', '');
          }
          this.fetchSubjects(newValue);
        }
      });

      if (this.parentValue) {
        this.fetchSubjects(this.parentValue);
      }
    } else {
      this.fetchSubjects(this.parentValue);
    }
  },
  props: {
    name: { type: String, required: true },
    label: { type: String, default: 'Destinos' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    nested: { type: Boolean, default: true },
    parentValue: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    isClearable: { type: Boolean, default: true }
  }
};

</script>
